var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.851,
    y1: 0.886,
    x2: 0.19,
    y2: 0.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#842bd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff007e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#ff474b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#ff8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#ffa30a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-in-button",
    transform: "translate(-1836 -51.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M21942-6748a23.832,23.832,0,0,1-9.34-1.886,23.872,23.872,0,0,1-7.629-5.143,23.889,23.889,0,0,1-5.143-7.627A23.815,23.815,0,0,1,21918-6772a23.826,23.826,0,0,1,1.887-9.344,23.906,23.906,0,0,1,5.143-7.629,23.891,23.891,0,0,1,7.629-5.144A23.832,23.832,0,0,1,21942-6796a23.858,23.858,0,0,1,9.344,1.886,23.934,23.934,0,0,1,7.629,5.144,23.906,23.906,0,0,1,5.143,7.629A23.826,23.826,0,0,1,21966-6772a23.815,23.815,0,0,1-1.887,9.341,23.9,23.9,0,0,1-5.143,7.627,23.915,23.915,0,0,1-7.629,5.143A23.851,23.851,0,0,1,21942-6748Zm0-46a21.846,21.846,0,0,0-8.562,1.729,21.922,21.922,0,0,0-6.992,4.715,22.027,22.027,0,0,0-4.715,6.994A21.882,21.882,0,0,0,21920-6772a21.882,21.882,0,0,0,1.727,8.563,22.016,22.016,0,0,0,4.715,6.994,21.91,21.91,0,0,0,6.992,4.715A21.846,21.846,0,0,0,21942-6750a21.872,21.872,0,0,0,8.566-1.729,21.936,21.936,0,0,0,6.992-4.715,22.016,22.016,0,0,0,4.715-6.994A21.882,21.882,0,0,0,21964-6772a21.882,21.882,0,0,0-1.727-8.563,22,22,0,0,0-4.715-6.994,21.927,21.927,0,0,0-6.992-4.715A21.872,21.872,0,0,0,21942-6794Z",
    transform: "translate(-20082 6848)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(1848 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M12,12A6,6,0,1,0,6,6a6,6,0,0,0,6,6ZM12,2A4,4,0,1,1,8,6a4,4,0,0,1,4-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M12,14a9.01,9.01,0,0,0-9,9,1,1,0,1,0,2,0,7,7,0,1,1,14,0,1,1,0,0,0,2,0A9.01,9.01,0,0,0,12,14Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7be660efff1c20931504bf2c26243915.svg";
export { ForwardRef as ReactComponent };